<template>
  <div
    class="text-[var(--foreground)] dark:bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] bg-[#eaeaea] overflow-hidden relative"
    v-show="hydrated"
  >
    <WrOfficialPartnerHeader />
    <WrHeader />

    <div class="pt-10 mt-32">
      <slot />
    </div>

    <section
      class="grid place-items-center z-10 relative pt-10 max-md:px-4 overflow-hidden"
      id="mask-section"
    >
      <ClientOnly>
        <WrAnimatedImg />
      </ClientOnly>
    </section>
    <WrFooter />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
const hydrated = ref(false);
onMounted(() => {
  hydrated.value = true;
});
</script>
